import { DefaultLoadingContent, MagicLoadingContent } from '@app/shared/ui/molecules/Common';
import { cn } from '@app/shared/utils/common';
import { loadingPanda, pandaShadow } from '@app/assets';

interface LoadingProps {
  type?: 'default' | 'magic';
}

export function Loading({ type = 'default' }: LoadingProps) {
  return (
    <div
      className={cn('fixed inset-0 z-1000', 'bg-background-gradient')}
      style={{ backgroundColor: '#040A19' }}
    >
      <div className="mx-auto max-w-lg px-5 pt-[95px] sm:pt-[135px]">
        {type === 'default' ? <DefaultLoadingContent /> : <MagicLoadingContent />}

        <div className="relative -right-[60px] mx-auto mt-10 w-[340px] sm:-right-[80px] md:-right-[110px]">
          <img
            src={loadingPanda}
            alt="meditating panda"
            className={cn('w-full object-contain', 'animate-magic-loading-panda')}
          />
          <img
            src={pandaShadow}
            alt="panda shadow"
            className="absolute -bottom-[60px] left-10 w-3/4"
          />
        </div>
      </div>
    </div>
  );
}
